<template>
    <div class="f-goods-list"
      v-on:click="onClickGoods">
        <div class="image-wrap">
            <slot name="flag"></slot>
            <img class="goods-img ui-imglazyload" src="//cdn.upin.com/mfanhuan/images/home/brand_Return/brand_return_load_alpha_368.png?v=20160216"
              :alt="goods.Title"
              :data-src="goods.ImagUrl">
            <i class="icon-solded" v-if="goods.solded">抢光啦</i>
        </div>
        <div class="content">
            <div class="title">
                <span class="tag">{{ goods.MallName }}</span>
                <span class="text">{{ goods.Title }}</span>
            </div>
            <div class="price-box" v-bind:class="{'multiple': goods.type === 'chaogao' || goods.type === 'lingquan'}">
                <div class="now-price">
                    <span class="rmb">¥</span>
                    <span class="integer">{{ goods.integer }}</span>
                    <span class="float">{{ goods.float }}</span>
                </div>
                <div class="origin-price" v-if="(goods.type === 'zhekou' || goods.type === 'fanhuan') && goods.NowPrice != goods.OldPrice">{{ goods.OldPrice }}</div>
                <div class="origin-price" v-if="goods.type === 'chaogao'">
                    <span class="before-price">支付{{ goods.NowPrice }}</span>
                    <span class="discount">返还{{ goods.ReturnPrice }}</span>
                </div>
                <div class="origin-price" v-if="goods.type === 'lingquan'">
                    <span class="before-price">支付{{ goods.NowPrice }}</span>
                    <span class="discount">领券减{{ goods.ReturnPrice }}</span>
                </div>
            </div>
            <div class="oprate">
                <div class="progress">
                    <span class="loading" :style="{ width: goods.HasSaleRate + '%'}"></span>
                    <span class="text">已抢{{ goods.HasSaleRate }}%</span>
                </div>
                <div class="btn"
                  :class="goods.solded ? 'gray' : 'red'">{{ goods.btnText }}</div>
            </div>
            <div class="sale-amount"
              :class="goods.solded ? 'gray' : ''"
              v-if="goods.HasSaleNum">{{ goods.HasSaleNum }}人抢购</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'f-goods-list',
        props: {
            goods: {
                type: Object,
                required: true
            }
        },
        methods: {
            onClickGoods: function () {
                this.$emit('goods-click', JSON.parse(JSON.stringify(this.goods)))
            }
        }
    }
</script>

<style lang="stylus">
    .f-goods-list
        position: relative
        display: -webkit-box
        display: -webkit-flex
        display: flex
        background-color: #fff
        padding-top: 5px
        .image-wrap
            width: 140px
            height: 140px
            position: relative
            .goods-img
                width: 100%
            .icon-solded
                position: absolute
                left: 50%
                top: 50%
                width: 85px
                height: 85px
                margin-left: -43px
                margin-top: -43px
                font-size: 15px
                font-style: normal
                color: #fff
                text-align: center
                line-height: 85px
                background: url(//image.fanhuan.com/mfanhuan/images/home/icon_sold.png) no-repeat
                background-size:85px 85px
                z-index: 10
        .content
            -webkit-box-flex: 1
            -webkit-flex: 1
            flex: 1
            box-flex: 1
            margin: 0 9px 0 11px
            width: 0
            .title
                padding-top: 11px
                overflow: hidden
                text-overflow: ellipsis
                white-space: nowrap
                line-height: 16px
                .tag
                    font-size: 11px
                    position: relative
                    color: #ff5555
                    border-radius: 2px
                    background: #ffd9d9
                    padding: 1px 2px
                    top: -1px
                .text
                    color: #333
                    font-size: 14px
            .price-box
                display: -webkit-box
                display: -webkit-flex
                display: flex
                height: 54px
                -webkit-box-align: end
                -webkit-align-items: flex-end
                align-items: flex-end
                box-sizing: border-box
                .now-price
                    color: #ff5555
                    font-size: 0
                    font-weight: bold
                    margin-right: 20px
                    .rmb
                        font-size: 14px
                        margin-right: 2px
                    .integer
                        font-size: 22px
                    .float
                        font-size: 14px
                .origin-price
                    font-size: 14px
                    color: #aaa
                    position: relative
                    top: -3px
                    text-decoration: line-through
            .price-box.multiple
                -webkit-box-items: center
                -webkit-align-items: center
                align-items: center
                padding-top: 18px
                .origin-price
                    font-size: 12px
                    background: url(//cdn.upin.com/mfanhuan/images/home/parentheses.png) no-repeat
                    background-size: 2px 28px
                    line-height: 16px
                    top: 0
                    padding-left: 9px
                    text-decoration: none
                    .before-price
                        display: block
                        margin-top: -2px
                    .discount
                        display: block
                        color: #000
            .oprate
                display: -webkit-box
                display: -webkit-flex
                display: flex
                -webkit-box-pack: justify
                -webkit-justify-content: space-between
                justify-content: space-between
                -webkit-box-align: end
                -webkit-align-items: flex-end
                align-items: flex-end
                .progress
                    width: 80px
                    box-sizing: border-box
                    border-radius: 25px
                    height: 12px
                    color: #fff
                    overflow: hidden
                    font-size: 10px
                    position: relative
                    background-image: -webkit-gradient(linear, left top, left bottom, from(#ffc5c5), to(#ffc5c5))
                    background-image: -webkit-linear-gradient(top, #ffc5c5, #ffc5c5)
                    background-image: linear-gradient(to bottom, #ffc5c5, #ffc5c5)
                    display: -webkit-box
                    display: -webkit-flex
                    display: flex
                    -webkit-box-pack: center
                    -webkit-justify-content: center
                    justify-content: center
                    -webkit-box-align: center
                    -webkit-align-items: center
                    align-content: center
                    &:before
                        content: ''
                        position: absolute
                        top: -50%
                        bottom: -50%
                        left: -50%
                        right: -50%
                        -webkit-transform: scale(0.5)
                        transform: scale(0.5)
                        border: 1px solid #ff5550
                        border-radius: 25px
                        -webkit-appearance: none
                    .loading
                        background: #ff5550
                        position: absolute
                        left: 0
                        top: 0px
                        height: 12px
                        width: 0
                        z-index: 1
                        border-radius: 25px
                        background-clip: padding-box
                        transition: width 250ms ease-in-out
                    .text
                        position: relative
                        z-index: 2
                .btn
                    width: 60px
                    text-align: center
                    line-height: 26px
                    color: #fff
                    font-size: 12px
                    border-radius: 3px
                .btn.red
                    background: #ff5550
                .btn.gray
                    background: #ddd
            .sale-amount
                margin-top: 4px
                color: #ff5550
                height: 14px
                font-size: 12px
                text-align: right
            .sale-amount.gray
                color: #ddd
</style>



// WEBPACK FOOTER //
// goods-list.vue?3579921b